module.exports = __webpack_public_path__ + "static/my-account-0c72123aa8a8d2f26f8b63e8262b8ede.png";